import React, {useState} from "react";
import './BottomCardInt.css';


function BottomCardInt(prop){
    let item = prop?.cardData;
    return (
        <div className="carouselCard">
            <h4>{item?.title}</h4>
            <p>
                <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-points-group.png" alt="points" width={28}/>{item?.subTitle}
            </p>
            <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-sale-card-next-icon.png" alt="next" width={30}/>
        </div>
    );

}

export default BottomCardInt;
